

import {Interaction as InteractionType} from "@/types/interaction";
import Interaction from "@/Molecules/Interaction/Interaction";
import Pagination from "@/Molecules/Pagination/Pagination";
import {usePage} from "@inertiajs/react";

type InteractionsProps<T extends Record<string, unknown> = Record<string, unknown>> = T & {
  // interactions: InteractionType[],
  interactions: {
    data: InteractionType[],
    pages: number,
    page: number,
  },
  onAddReply: (interactionId: number, input: string) => Promise<boolean>,
  onAddHeart: (interactionId: number) => Promise<boolean>,
  onExamine?: (interactionId: number, accepted: boolean) => void,
  // onNavigatePage: (page: number) => void,
  asPreview?: boolean
};
export default function Interactions(
  {
    interactions,
    onAddReply,
    onAddHeart,
    onExamine,
    // onNavigatePage,
    asPreview
  }: InteractionsProps) {

  const handleNavigatePage = (page: number) => {
    const baseUrl = location.pathname;
    location.href = `${baseUrl}?page=${page}#interactions`
  }

  return <div className={'flex flex-col gap-3'}>
    {interactions.data.map((interaction, index) => <Interaction
      key={index}
      {...interaction}
      onOpenReply={(input: string) => onAddReply(interaction.id, input)}
      asPreview={asPreview}
      onAddHeart={onAddHeart}
    /> )}
    {interactions.data.length === 0 && <div>
      Er zijn nog geen condoleances geplaatst.
    </div>}
    <Pagination page={interactions.page || 1} pages={interactions.pages} onChange={(page) => handleNavigatePage(page)} />
  </div>
}
